<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
};
</script>

<style scoped>
#app {
  font-family: "Poppins", sans-serif;
  background-color: #fff5f5;
}
</style>
